import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModelData, { IUserData } from "../../../public/model_data";
import * as GameProto from "../../net/proto/proto_bullbull_game";
import BullBullPlayerInfo from "./bullbull_player_info";
import CardMoveCom from "./com/card_move_com";
import CardSelfMgrCom from "./com/card_self_mgr_com";
import GameUtil from "../../../../utility/game_util";
import BullBullConst from "../utils/bullbull_const";
import Utility from "../../../../utility/utility";
import LanguageManager from "../../../../manager/language_manager";
import UserDataManager from "../../../../manager/user_manager";
import { BullBullRoom } from "../../net/proto/proto_bullbull_room";
import BullPlayerInfoNode from "./com/bull_player_info_com";
import BullCardValueCom from "./com/bull_card_value_com";
import TableClock from "../../../table/components/table_clock";
import BullRobCardCom from "./com/bull_rob_card_com";
import BullResultCom from "./com/bull_result_com";
import LoaclStorage from "../../../../manager/local_storage";
import TableBaseView from "../../../table/module/table_base/table_base_view";
import TablePokerBase from "../../../table/module/table_base/table_poker_base";

const { ccclass, property } = cc._decorator;

@ccclass
export default class  BankerBullBullTableView extends TableBaseView
{

    @property([cc.Button])
    public bankerButtons : cc.Button[] = [];

    @property([cc.Node])
    public playerNodes : cc.Node[] = []

    private iconButtons : cc.Button[] = [];

    @property([cc.Node])
    public coinMoveNodes : cc.Node[] = [];

    @property([cc.Button])
    public betButtons : cc.Button[] = [];
  
    @property(cc.Label)
    public roomNumLabel : cc.Label = null;

    @property(TableClock)
    public tableClock : TableClock = null;
    
    @property([cc.Node])
    public tableCardNodes : cc.Node[] = [];

    @property(cc.Node)
    public pokerAniNode : cc.Node = null;

    @property(cc.Node)
    public selfCardNode : cc.Node = null;

    @property(cc.SpriteAtlas)
    public pokerAtlas : cc.SpriteAtlas = null;

    @property(cc.Node)
    public calculateNode : cc.Node = null;

    @property(cc.Node)
    public tipNode : cc.Node = null;

    @property(cc.Button)
    public continueButton : cc.Button = null;

    @property(cc.Font)
    public add_font : cc.Font = null;

    @property(cc.Font)
    public sub_font : cc.Font = null;

    @property(cc.Font)
    public scramble_banker_font : cc.Font = null;

    @property(cc.Font)
    public lock_banker_font : cc.Font = null;    

    @property(cc.Node)
    public spriteFrameNode : cc.Node = null;

    @property(cc.Node)
    public nodeAnimation : cc.Node = null;

    @property(cc.Label)
    public roomStaticLabel : cc.Label = null;

    @property(cc.Node)
    public unCorrectNode : cc.Node = null;

    @property(cc.Label)
    public dizhuLabel : cc.Label = null;

    @property(cc.Node)
    public startCDNode : cc.Node = null;

    @property(cc.Button)
    public reconnect : cc.Button = null;

    @property(cc.Node)
    public exp_node : cc.Node = null;

    @property(cc.Node)
    public robNode : cc.Node = null;

    @property(cc.Node)
    public winResultNode : cc.Node = null;

    @property(cc.Node)
    public lossResultNode : cc.Node = null;

    //自动开牌
    @property(cc.Node)
    public autoNode : cc.Node = null;

    /**
     * 是否为看牌抢庄
     */
    private isWatchAndRob : boolean;

    private tableAniMap : Map<string,cc.NodePool> ;

    private countDown : number;
    private startCD : number = 0;
    private dealPokerAniId = 0;    
    private selfPokerMoveId = 0;


    private avatarId : number;
    constructor(){
        super();       

        this.tableAniMap = new Map();
    }

    public onShow(){
        super.onShow();
        this.showBankerButtons(false);     
        this.avatarId = ModelData.instance.roleData.id;  
    }


    public showAutoPoker(show : boolean, isAuto? : boolean){

        //暂不显示
        return;
        cc.warn("  showAutoPoker " ,show, " isAuto " , isAuto)
        if (show) {
         
            let cancelAutoBg = this.autoNode.getChildByName("cancel_auto_bg");
            let isAutoBg = this.autoNode.getChildByName("auto_bg");

            isAutoBg.active = isAuto;
            cancelAutoBg.active = !isAuto;
        }        
        
        this.autoNode.active = show;
    }

    public setAutoToggle(check : boolean){        
        
    
        let toggle = this.autoNode.getComponent(cc.Toggle);
        toggle.isChecked = check;
    }


    public onHide(){

        //this.unschedule(this.onCountDown);
    }

    public updateDizhu(dizhu : string){
        
        this.dizhuLabel.node.parent.active = true;
        this.dizhuLabel.string = LanguageManager.t("Public＿BottomPouring") +  GameUtil.currencyFormatting(Number(dizhu));
    }

    public updateRoomNum(num : string){
        this.roomNumLabel.string = num;
    }

    public updaetRoomStaticLabel(state : boolean){

        this.roomStaticLabel.node.active = state;
    }

    public setIsWatchAndRob(state : boolean){
        this.isWatchAndRob = state;
    }

    public tranferCard(){

        //转动最后一张牌
        let poker_4 = this.selfCardNode.getChildByName("Poker_4");
        
        let ani = poker_4.getComponent(cc.Animation);
        ani.resume();
        ani.play();      
    
    }


    public setLastCardAplha(alpha : number){

        let poker_4 = this.selfCardNode.getChildByName("Poker_4");

        poker_4.opacity = alpha;
    }

    
    public updatePlayerInfo(seatSide : number, balance : string,playerId : number ,addNum? : string,userJson? : any){        
        let node : cc.Node = this.playerNodes[seatSide];        
        if (!node) return;   
        
        cc.log(" updatePlayerInfo playerId " , playerId  , "seatSide ",  seatSide  +  " gold " , balance);
                
        let infoCom = node.getComponent(BullPlayerInfoNode);

        if (playerId) {                          
            if (userJson) {            
                UserDataManager.setUserJsonData(userJson);
            }        

            let avatar = this.getAvatarById(seatSide)
            if(!avatar){
                let node_icon = node.getChildByName("Node_Icon")
                avatar = this.addAvatarById(seatSide, playerId, node_icon)
            }

            infoCom.avatarCom = avatar;

            this.iconButtons[seatSide] = avatar.buttonAvatar;
            
            this.showPlayerIconState(node,true,playerId);
                 
            if (balance) {
                infoCom.updateBalance(Number(balance));
                UserDataManager.setUserGameTableCurrency(playerId,Number(balance));
            }

            cc.Graphics.LineCap.ROUND

            let label_num = node.getChildByName("Label_Num");
            if (label_num && addNum) {

                let label = label_num.getComponent(cc.Label);

                if (addNum.indexOf("-") == -1) {
                    
                    label.font = this.add_font;                
                    label.string = "+" + addNum;
                }
                else{

                    label.font = this.sub_font;
                    label.string = addNum;
                }
            }

            node.active = true;

        }
    }

    public getSeatNodeById(seatSide : number) : cc.Node{

        return this.iconButtons[seatSide].node;

    }


    /**
     * 
     * @param seatSide 
     * @param state true 表示显示头像 false 显示底板遮罩
     */
    public showPlayerIconState(node : cc.Node, state : boolean,playerId ? : number){

        let infoCom = node.getComponent(BullPlayerInfoNode);
        if (infoCom) {
            infoCom.showAvatar(state,playerId);
        }


        // if (!state) {
            
        //     let node_icon = node.getChildByName("Node_Icon");           
        //     node_icon.getChildByName("Node_ShowBody").active = false;
        //     node_icon.getChildByName("Sprite_Nobody_BG").active = true;

        //     node.getChildByName("Label_Name").getComponent(cc.Label).string = " ";
        //     node.getChildByName("Label_Gold").getComponent(cc.Label).string = " ";

        // }else{

        //     let node_icon = node.getChildByName("Node_Icon");           
        //     node_icon.getChildByName("Node_ShowBody").active = true;
        //     node_icon.getChildByName("Sprite_Nobody_BG").active = false;
        // }
    }

    /**
     * 随机庄家动画
     */
    public showIconFrame(seatSide : number){

        let mid_node = this.getPlayerInfoCom(seatSide).avatarMidNode;
        if (mid_node) {

            //this.spriteFrameNode.parent = null;
            this.spriteFrameNode.parent = mid_node;
            this.spriteFrameNode.position = cc.Vec3.ZERO;
            this.spriteFrameNode.active = true;        
            
            mid_node.active = true;
            //cc.log(" randomIconFrame seatSide " + seatSide);
            this.playSoundInTable("scramble_random")
        }
    }

    /**
     * 定庄动画
     */
    public addBankerLockAni(seatSide : number){

        let node : cc.Node = this.playerNodes[seatSide];

        let self = this;

        this.playAni("anim_niuniu_touxiangkang_dingzhuang",(load_dingzhuang)=>{

            let node_scamble = node.getChildByName("Node_ScambleFrame");
            load_dingzhuang.parent = node_scamble;   
            load_dingzhuang.position = cc.Vec3.ZERO;     
            
            self.playAni("anim_niuniu_zhuang",(load_zhuang)=>{

                let node_banker = node.getChildByName("Node_Banker");
                load_zhuang.parent = node_banker;   
                //左边or右边
                load_zhuang.position = seatSide < 5 ? new cc.Vec3(-71.308,62.399) : new cc.Vec3(66.137,62.399);
                
                self.playSoundInTable("scramble_over")
            });
        },2);      

        this.changeScramble(seatSide,true);
    }

    public addGoldFrame(seatSide : number){

        console.warn("  addGoldFrame " , seatSide);
        let self = this;
        this.playAni("anim_niuniu_touxiangkang_addGold",(load_dingzhuang)=>{            
            load_dingzhuang.parent = self.getPlayerInfoCom(seatSide).avatarMidNode;   
        });
    }

    public playAni( name : string,  callback? : ( loadNode : cc.Node) => void,lifeTime ? :number ){

        let self = this;
        let url = BullBullConst.PREFAB_RES_PATH_BASE +　"animation/" + name;

        let pool = this.tableAniMap.get(url);

        if (pool && pool.size() > 0) {
            let aniNode = pool.get();

            if (aniNode) {
                if (callback) {
                    aniNode.active = true;
                    let ani = aniNode.getComponent(cc.Animation);
                    if (ani) {
                        ani.resume();
                        ani.play();
                    }
                    callback(aniNode);
                }    

                if (lifeTime > 0) {
                    self.doScheduleOnce(()=>{                    
                        self.removeAni(aniNode);                        
                    },lifeTime)
                }        
                
                //更新map
                this.tableAniMap.set(url,pool);
                return;
            }            
        }
        
        this.loadRes(url,function(error,prefab)
        {
            if (error) {
                cc.warn(" load prefab error ",url);
                return;
            }

            let node = cc.instantiate(prefab);

            if (callback) {
                node.active = true;
                let ani = node.getComponent(cc.Animation);
                if (ani) {
                    ani.resume();
                    ani.play();
                }
                callback(node);
            }

            if (lifeTime > 0) {
                
                self.doScheduleOnce(()=>{
                    self.removeAni(node);                        
                },lifeTime)
            }
        });

        // this.loadRes(url,function(error,prefab)
        // {
        //     if (error) {
        //         cc.warn(" load prefab error ",url);
        //         return;
        //     }

        //     let node = cc.instantiate(prefab);
        //     if (callback) {
                
        //         callback(node);
        //     }

        //     if (lifeTime > 0) {
                
        //         self.doScheduleOnce(()=>{
        //             self.removeAni(node);                        
        //         },lifeTime)
        //     }
        // }); 
        
                       
    }

    public removeAni(node : cc.Node,use? : string){

        console.log(" removeAni : " , node.name);

        let url = BullBullConst.PREFAB_RES_PATH_BASE +　"animation/" + node.name;

        let pool = this.tableAniMap.get(url);
        if (!pool) {
            pool = new cc.NodePool();
        }
        pool.put(node);

        this.tableAniMap.set(url,pool);
        
        //this.releaseRes(node,url,use);
    }

    public removePlayer(isAll : boolean, seatSide? : number){

        if (isAll) {
            
            this.playerNodes.forEach(node => {
            
                //node.active = false;
                this.showPlayerIconState(node,false);
            });
        }
        else{         
            //清理玩家头像
            this.showPlayerIconState(this.playerNodes[seatSide],false);                
            //重置                
            this.resetPlayer(seatSide);
                                                                            
        }
    }

    /**
     * 重置
     * @param seatSide 
     */
    public resetPlayer(seatSide : number){

        cc.warn(" resetPlayer " , seatSide);
        let playerNode : cc.Node = this.playerNodes[seatSide]; 
        //输赢数字
        let label_num = playerNode.getChildByName("Label_Num").getComponent(cc.Label);
        label_num.string = "";
        
        //抢庄倍数       
        this.hideScrambleResult(false,seatSide);

        //下注倍数
        let bet = playerNode.getChildByName("Node_Bet");
        bet.active = false;
        //框
        let node_scamble = playerNode.getChildByName("Node_ScambleFrame");
                   
        while(node_scamble.children.length){

            let child = node_scamble.children[0];
            child.active = false;
            this.removeAni(child);  
        }

        //avatar 头像特效
        let midNode = this.getPlayerInfoCom(seatSide).avatarMidNode;
        if (midNode) {
            
            //转移parent
            while(midNode.children.length){

                let child = midNode.children[0];
                if (child.name == this.spriteFrameNode.name) {
                    
                    child.active = false;
                    child.parent = playerNode.parent.parent;
                }else{
                    
                    this.removeAni(child);
                }
            }
        }
        
        //banker
        let node_banker = playerNode.getChildByName("Node_Banker");                        
        while(node_banker.children.length){

            let child = node_banker.children[0];
            child.active = false;
            this.removeAni(child);
        }
        
        //mask        
        this.showIconMask(false,seatSide);
        
        //清理玩家牌桌         
        let table_side = this.tableCardNodes[seatSide];                       
        table_side.active = false;
        let cow = table_side.getChildByName("Sprite_Cow") ;
        cow.active = false;            

        
        

        this.showSelfCard(false);
        
    }

    public resetTable(){
        
        this.nodeAnimation.children.forEach(aniNode =>{

            //this.releaseRes(ani,ani.name);
            this.removeAni(aniNode);

        });

        this.unschedule(this.updateStartCD);
        //this.unschedule(this.onCountDown);

       
    }

    public startGame(){

        this.playSoundInTable("start_game");
    }

    public showContinueBtn( state : boolean){
                        
        this.continueButton.node.active = state;
        
    }

    public showUncorrectNode(state : boolean){

        this.unCorrectNode.active = state;
    }

    private daojishiId : number;
    public showCountDown(countdown : number){
        cc.warn(" showCountDown "  ,countdown);

        let newCD = Math.floor(countdown);
        let offset = countdown - newCD;

        if (offset >= 0 ) {            
            let self = this;
            this.doScheduleOnce(()=>{
                self.tableClock.showClock(true,newCD,false,null,(secs)=>{
                    if (secs == 3) {
                        //播放声音   
                        self.playSound("package/bullbull/audio/daojishi",false,null,(id)=>{
                            self.daojishiId = id;
                        });                     
                    }     
                    
                    if (self.robNode.active) {
                        let robCom = self.robNode.getComponent(BullRobCardCom);
                        if (robCom) {
                            robCom.updateTime(newCD);            
                        }     
                    }
                    
                    // if (self.robNode.active) {
                    //     let robCom = self.robNode.getComponent(BullRobCardCom);
                    //     if (robCom) {
                    //         robCom.updateTime(secs);            
                    //     }     
                    // }     
                });                

                //self.tableClock.showClock(true,newCD + 1);
            },offset)
        }

        // countdown = Math.round(countdown);
        // //countdown = Math.floor(countdown);
        // if (countdown < 0 ) {            
        //     return;
        // }
        // //this.countDownNode.active = true;
        // //this.countDown = countdown;

        // this.tableClock.showClock(true,countdown);
        
        // let CDLabel = this.countDownNode.getComponentInChildren(cc.Label);
        // CDLabel.string = this.countDown.toString();
        // this.unschedule(this.onCountDown);
        // this.schedule(this.onCountDown,1,countdown);

        //cc.log(" showCountDown ",countdown);
    }

    public showStartCountDown(cd : number){
 
        cc.warn("  showStartCountDown " , cd);
        //cd = Math.round(cd);
        //cd = Math.floor(cd);

        let newCD = Math.floor(cd);
        let offset = cd - newCD;

        let self = this;
        if (offset == 0) {
            
            self.startCD = newCD;

            let cd_label = self.startCDNode.getChildByName("cd_Label").getComponent(cc.Label);         
            cd_label.string =  LanguageManager.t("dz_startnext").format(self.startCD);
            self.startCDNode.active = true;

            self.unschedule(self.updateStartCD);
            self.schedule(self.updateStartCD,1,self.startCD);

            self.eventDispatch('update_seek_player',0,0);
        }

        else if (offset > 0) {            
            
            this.doScheduleOnce(()=>{
              
                self.startCD = newCD;

                let cd_label = self.startCDNode.getChildByName("cd_Label").getComponent(cc.Label);         
                cd_label.string =  LanguageManager.t("dz_startnext").format(self.startCD);
                self.startCDNode.active = true;
    
                self.unschedule(self.updateStartCD);
                self.schedule(self.updateStartCD,1,self.startCD);
    
                self.eventDispatch('update_seek_player',0,0);

            },offset)

        }


        // if (cd < 0 ) return;        

        // this.startCD = cd;
        // if (cd>0) {
            
        //     let cd_label = this.startCDNode.getChildByName("cd_Label").getComponent(cc.Label);         
        //     cd_label.string =  LanguageManager.t("dz_startnext").format(this.startCD);
        //     this.startCDNode.active = true;

        //     this.unschedule(this.updateStartCD);
        //     this.schedule(this.updateStartCD,1,cd);

        //     this.eventDispatch('update_seek_player',0,0);
            
        //     //this.hideWating();

        // }else{

        //     this.unschedule(this.updateStartCD);
        //     this.startCDNode.active = this.startCD > 0? true : false;
        //     //this.updateStartCD();
        // }

    }

    private updateStartCD(){

        --this.startCD;

        this.startCDNode.active = this.startCD > 0? true : false;

        if (this.startCD > 0) {
 
            let cd_label = this.startCDNode.getChildByName("cd_Label").getComponent(cc.Label);         
            cd_label.string =  LanguageManager.t("dz_startnext").format(this.startCD);
        }         
        else{

            this.startCD = 0;
        }        
    }

    public hideStartCountDown(){

        cc.warn("  hideStartCountDown ");
        this.startCDNode.active = false;
        this.unschedule(this.updateStartCD);
    }

    public showTableTips(show : boolean, content? : string){        
        cc.warn(" showTableTips " , show);
        this.tipNode.active = show;
        if (content) {
            
            let label = this.tipNode.getComponentInChildren(cc.Label);
            label.string = content ;   
        }        
    }

    private onCountDown(){
        //cc.log(" oncount down ..");

        // let CDLabel = this.countDownNode.getComponentInChildren(cc.Label);
        // CDLabel.string = (--this.countDown).toString();

        // if (this.countDown == 0) {
            
        //     this.hideCountDown();
        // }
    }

    public hideCountDown(){
   
        //this.countDown == 10;
            
        //this.countDownNode.active = false;

        this.tableClock.showClock(false);
        this.showTableTips(false);
        
        this.stopSound(this.daojishiId);

        //this.unschedule(this.onCountDown);
        
    }

    /**
     * 显示抢庄倍数
     * @param maxNum 最大抢庄倍数
     * @param show 是否显示
     */
    public showBankerButtons(show  : boolean,maxNum? : number){


        cc.warn(" showBankerButtons " , show);

        if (show) {
            
            for (let index = 0; index < this.bankerButtons.length; index++) {
                const btn = this.bankerButtons[index];                                
                
                btn.node.active = true;
                btn.enabled = index <= maxNum ? true : false;
                btn.interactable = index <= maxNum ? true : false;
                let lab = btn.node.getComponentInChildren(cc.Label);
                if (btn.interactable) {
                    Utility.resetGray(lab);
                }else{
                    Utility.setGray(lab);
                }
                //btn.node.active = index <= maxNum ? true : false;
            }

        }else{

            this.bankerButtons.forEach(button => {
           
                button.node.active = false;
            });
        }
    }

    /**
     * 显示下注倍数
     */
    public showBetButtons(timesList : (number)[])
    {                

        cc.warn(" showBetButtons " , timesList);
        
        let currentTimes ;
        for (let index = 0; index < this.betButtons.length; index++) {
            const btn = this.betButtons[index];
            
            btn.node.active = true;
            if (timesList.length > index && timesList[index] != 0) {
                
                currentTimes = timesList[index];
                btn.interactable = true;     
                            
            }
            else{

                currentTimes += 1;
                btn.interactable = false;                                
            }

            let label = btn.getComponentInChildren<cc.Label>(cc.Label);
            if (label) {                    
                //label.string = currentTimes.toString() + LanguageManager.t("public_times");
                label.string = currentTimes.toString() + "a";

                if (btn.interactable) {
                    Utility.resetGray(label);
                }else{
                    Utility.setGray(label);
                }
                
            }
        }
    }

    public hideAllBetButton()
    {
        this.betButtons.forEach(btn => {
            
            btn.node.active = false;
        });
    }


    public checkClickResult() : boolean{

        let cardMgr = this.selfCardNode.getComponent(CardSelfMgrCom);
        return cardMgr.checkCow();
    }
    
    public updateLastCard(plyaerId : number, poker : GameProto.BullBullGame.IPoker,comboType  : string,isReconnect? : boolean){


        let child = this.selfCardNode.getChildByName("Poker_4");
        child.active = true;

        let com = child.getComponent(BullCardValueCom);
        com.updateCard(plyaerId,poker.number,poker.colour);
        com.showBack(plyaerId,false);

        let cardMgr = this.selfCardNode.getComponent(CardSelfMgrCom);
        cardMgr.recvCombo(comboType);   

        //cardMgr.recvClickOpen(true);

        //this.showCalculate(true);

        this.updateRobbingCard(poker);

        if (!isReconnect) {         
            this.showCowBtn(true);
        }        
        
    }

    public updateRobbingCard(poker : GameProto.BullBullGame.IPoker){
        
        let com = this.robNode.getComponent(BullRobCardCom);
        com.updateCard(this.avatarId, poker);
    }

    /**
     * 开始发牌 
     */
    public startDealPoker( playerMap : { [key:number] : BullBullPlayerInfo }, 
                            playerId : number,
                            pokers :  GameProto.BullBullGame.IPoker[],
                            comboType : string,
                            callback ? : Function,
                            isReconnect? : boolean,
                            roomState? : number,
                             ) {

        let self = this;
        let pokerCount = pokers ? pokers.length : 0;


        // if(pokerCount == 4){
        //     //补一张牌
        //     //let poker = new GameProto.BullBullGame.Poker({number:"0",colour:"0"}) ;                        
        //     //pokers_new.push(poker);
        // }        

        if (!this.isWatchAndRob) {        
            this.hideAllBetButton();       
        }
     
                
        this.startDealPokerAni(playerMap,pokerCount, ()=>{
                       
            self.hidePokerAni(true);

            let cardMgr = self.selfCardNode.getComponent(CardSelfMgrCom);
            if (comboType) {
                             
                cardMgr.recvCombo(comboType);                  
            }

            if (pokerCount || comboType) {
                self.showSelfCard(true,pokerCount);    
            }
            
            if (pokers && pokers.length > 0) {
             
                //移牌动画
                self.cancelSchedule(self.selfPokerMoveId);

                if (pokerCount == 5 ) {
                 
                    if ( !isReconnect || (isReconnect && roomState > 2)) {
                     
                        self.selfPokerMoveId = self.doScheduleOnce( ()=>{                            

                            self.showCowBtn(true);
        
                        },0.25);
                    }                    
                    
                }else{

                    self.showCowBtn(false);
                }

            
                self.setClickSelfCard(!self.isWatchAndRob);
                //cardMgr.recvClickOpen(!self.isWatchAndRob); 
                

                if (pokers.length == 1){

                    let child = self.selfCardNode.getChildByName("Poker_4");
                    child.active = true;

                    //这时候不需要开启移动动画
                    // let moveCom = child.getComponent(CardMoveCom);
                    // moveCom.moveTo(-1);

                    self.updateLastCard(playerId, pokers[0],comboType,true);
                }
                else{
                    
                    //展示自己的牌..
                    for (let index = 0; index < pokers.length; index++) {                    

                        let child = self.selfCardNode.getChildByName("Poker_" + index.toString());
                        child.active = true;
                                          
                        let com = child.getComponent(BullCardValueCom);
                        com.updateCard(this.avatarId,pokers[index].number,pokers[index].colour);                    
                        com.showBack(this.avatarId,false);

                        let ani = child.getComponent(cc.Animation);
                        ani.resume();
                        ani.play();
                    }

                    if (pokers.length == 4) {
                        
                        let child = self.selfCardNode.getChildByName("Poker_4");
                        child.active = false;
                    }
                }
              
            }

            if (isReconnect && pokerCount > 4 && self.isWatchAndRob) {
            
                self.updateLastCard(playerId,pokers[4],comboType,true);
            }            


            self.showAllTableCard(false);        

            //展示其他玩家的牌背
            for (const key in playerMap) {
                if (playerMap.hasOwnProperty(key)) {
                    const info = playerMap[key];

                    if (info.isAvatar || !info.isBattle) {
                        continue;
                    }
                    
                    self.showTableCardBack(info.playerId,info.seatSide,pokerCount);
                }
            } 

            if(callback){
                callback();
            }
        });          
    }
    

    public setClickSelfCard(state : boolean){

        let cardMgr = this.selfCardNode.getComponent(CardSelfMgrCom);
        cardMgr.recvClickOpen(state); 
    }

    /**
     * 发牌动画
     * @param playerMap 
     * @param callback 
     */
    private startDealPokerAni(playerMap : { [key:number] : BullBullPlayerInfo }, pokerNum? : number, callback ? : Function ){
                
        this.showPokerAni(pokerNum,playerMap);              

        let self = this;
        this.dealPokerAniId = this.doScheduleOnce(()=>{                                    
          
            if (callback) {
                callback();   
                self.cancelDealPokerAni();                
            }            
        },1);        
    }
    

    public cancelDealPokerAni(){
        this.cancelSchedule(this.dealPokerAniId);
    }

    
    public showSelfCard( state : boolean,pokerCnt : number = 5 ){
        cc.warn(" showSelfCard ", state);
        this.selfCardNode.active = state;

        if (pokerCnt == 5) {        
            this.showCalculate(state);          
        }              

        if (!state) {  
            
            this.showCowBtn(false);

        }
    }

    public showCowBtn(state : boolean){
        
        cc.warn( " showCowBtn " ,state , " isWatchAndRob " , this.isWatchAndRob);
        let haveCow = this.selfCardNode.getChildByName("Button_HaveCow");
        haveCow.active = state && !this.isWatchAndRob && !this.getAutoShowPoker();            

        let noCow = this.selfCardNode.getChildByName("Button_NoCow");
        noCow.active = state && !this.isWatchAndRob && !this.getAutoShowPoker();      

        let robCard = this.selfCardNode.getChildByName("Button_RobCard");
        robCard.active = state && this.isWatchAndRob && !this.getAutoShowPoker();            

        let displayCard = this.selfCardNode.getChildByName("Button_DisplayCard");
        displayCard.active = state && this.isWatchAndRob && !this.getAutoShowPoker();

    }


    private getAutoShowPoker(){
        
        let value = LoaclStorage.getItem(ModelData.instance.roleData.id.toString() + "_bullbull_auto_show_poker");

        //暂屏
        return false;
        //return value == "1";
    }

    public showCalculate( state : boolean ){
        
        this.calculateNode.active = state && !this.isWatchAndRob;        
    }

    private showPokerAni( pokerNum : number, playerMap : { [key:number] : BullBullPlayerInfo }){

        cc.log(" showPokerAni ");
        let self = this;
        this.pokerAniNode.active = true;

        for (let index = 0; index < BullBullConst.MAX_SEAT_NUM; index++) {
            
            let child = this.pokerAniNode.children[index];                
            child.active = false;                
        }

        for (const key in playerMap) {
            if (playerMap.hasOwnProperty(key)) {
                const info = playerMap[key];

                let child = this.pokerAniNode.children[info.seatSide]; 
                let ani = child.getComponent(cc.Animation);

                let control = child.getChildByName("control");
                
                let pokerBaseList = control.getComponentsInChildren(TablePokerBase);
                if (pokerBaseList) {
                    pokerBaseList.forEach((pokerBase)=>{
                        pokerBase.uid = info.playerId;
                        pokerBase.onUpdateBack();
                    });
                }

                ani.resume(); 

                if(info.isBattle){
                    child.active = true;                                                
                    let defaultName = ani.defaultClip.name;
                    let aniName = pokerNum == 5? defaultName : pokerNum == 4? defaultName + "_4" : defaultName + "_1";
                    ani.play(aniName);

                    cc.log("  isBattle " , info.playerId);
                }else{
                    
                    child.active = false;
                    cc.log(" not isBattle " , info.playerId);

                }                                                           
            }
        }

        for (let index = 0; index < pokerNum; index++) {

            this.scheduleOnce(()=>{
                self.playSoundInTable("singlePoker")                    
            }, 
                            
            0.2 + index * 0.1);
        }
                
        
    }


    public hidePokerAni(isAll :boolean ,seatSide? : number){

        if (isAll) {
            
            for (let index = 0; index < BullBullConst.MAX_SEAT_NUM; index++) {
                
                let child = this.pokerAniNode.children[index];                
                child.active = false;                
            }        
        }
        else{

            let aniNode = this.pokerAniNode.children[seatSide];     
            aniNode.active = false;
        }

    }

    public showAllTableCard( state : boolean){

        for (let index = 0; index < BullBullConst.MAX_SEAT_NUM; index++) {
           
            this.tableCardNodes[index].active = state;            
        }
    }

    public showTableCardBack(playerId : number,seatSide : number,pokerCount : number){

        let node_dir = this.tableCardNodes[seatSide];
        node_dir.active = true;

        let child : cc.Node;
        if (pokerCount == 1) {

            child = node_dir.getChildByName("Sprite_Card4");
            child.active = true;

        }else{

            for (let index = 0; index < 5; index++) {
            
                child = node_dir.getChildByName("Sprite_Card" + index.toString());
    
                let value_com = child.getComponent(BullCardValueCom);
                value_com.showBack(playerId);
    
                if (pokerCount == 4) {                
                    child.active = index != 4;
                } else{
                    child.active = true;
                }        
    
                // let sprite = node_dir.getChildByName("Sprite_Card" + index.toString()).getComponent(cc.Sprite);
                // sprite.spriteFrame = this.pokerAtlas.getSpriteFrame("0");
                // sprite.node.active = true;
            }
        }        

        //node_dir.getChildByName("Sprite_Cow").active = false;
    }

    public showSelfTableCard(seatSide : number,pokers : GameProto.BullBullGame.IPoker[]){

        let node_dir = this.tableCardNodes[seatSide];
        node_dir.active = true;

        for (let index = 0; index < 5; index++) {
            
            let child = node_dir.getChildByName("Sprite_Card" + index.toString());
            let value_com = child.getComponent(BullCardValueCom);
            value_com.updateCard(this.avatarId,pokers[index].number,pokers[index].colour);
       
        }

    }

    /**
     * 比牌完成
     */
    public showPokerFinish(seatSide : number,state : boolean){

        let node_dir = this.tableCardNodes[seatSide];
        node_dir.active = true;

        node_dir.getChildByName("Sprite_Finish").active = state;

        cc.warn(" showPokerFinish " , state);
    }

    

    public showPlayerResult( playerId : number,  seatSide : number , comboType : string, pokers : GameProto.BullBullGame.IPoker[]){
                
        if (seatSide == 0) {
            
            this.showSelfCard(false);
        }

        this.showPokerFinish(seatSide,false);

        this.showPokerResultAni(playerId,seatSide,comboType,pokers);

    }


    private getSortType(comboType : string): number{

        //判断 5 / 4 + 1 /  3+2 排列 
        if ( comboType == "goldcow" || comboType == "samll" || comboType == "cow0") {
            //5            
            return 5;
        }                
        else if (comboType == "boom" || comboType == "silvercow"  ) {
            
            //4+1            
            return 4;
        }
        else{

            //3+2            
            return 3;
        }
    }

    /**
     * 搓牌
     */
    public showRubbing(state:boolean){
        
        this.robNode.active = state ;

    }

    /**
     * 摊牌动画
     */
    public showPokerResultAni(playerId : number,seatSide : number , comboType : string, pokers : GameProto.BullBullGame.IPoker[],
        ani_duration : number = 0.35,cow_ani_delay = 1 ){

        let node_dir = this.tableCardNodes[seatSide];
        node_dir.active = true;

        //let ani_duration = 0.35;

        let sortType = this.getSortType(comboType)
        pokers = this.sortPoker(sortType,comboType,pokers);

        let offsets = [];
        
        // 0 为原点
        if (sortType == 5) {
            
            //5
            offsets = seatSide == 0 ? [-165,-110,-55,0,55] : [-105,-70,-35,0,35];

    
        }
        else if(sortType == 4){

            //4+1
            offsets = seatSide == 0 ? [-165,-110,-55,0,75] :[-105,-70,-35,0,50];

        }
        else {

            //3+2            
            offsets = seatSide == 0? [-185,-130,-75,0,55] : [-120,-85,-50,0,35];

        }
        
        let self = this;
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];   
            
            console.log(" showPokerResultAni index " , index);

            let child = node_dir.getChildByName("Sprite_Card" + index.toString());
            child.active = true;                        
            
            let move_com = child.getComponent(CardMoveCom);
            let value_com = child.getComponent(BullCardValueCom);
            move_com.moveTo(ani_duration,null,function(poker : GameProto.BullBullGame.IPoker,offset_x){
                
                value_com.updateCard(playerId,poker.number,poker.colour);
                move_com.moveBy(ani_duration,new cc.Vec2(offset_x,0),null);
            }.bind(this,poker,offsets[index]));
        }

        //let cow_ani_delay = ani_duration * 2 + 0.3;
        this.doScheduleOnce(()=>{

            //牛几动画
            // let cowNode = node_dir.getChildByName("Sprite_Cow");
            // cowNode.active = true;
            
            // let dbCom = cowNode.getComponentInChildren(dragonBones.ArmatureDisplay);

            // dbCom.playAnimation(comboType,1);
            
            // if (seatSide == 0) {
            //     self.getUserData(Number(playerId), (data : IUserData) => {

            //         let gender = data.gender == 1? "female_" : "male_";
            //         self.playSoundInTable(gender + comboType,0.2);
            //     });
            // } 

            self.playCowAni(playerId,seatSide,comboType);
                   
            //this.updatePlayerInfo(seatSide,settle.coinBalanceStr,null,null/*,settle.actualWinLoss*/);            
                    

        },cow_ani_delay);       
                    
    }

    public playCowAni(playerId : number,seatSide : number,comboType : string){

        let node_dir = this.tableCardNodes[seatSide];
        node_dir.active = true;

        //牛几动画
        let cowNode = node_dir.getChildByName("Sprite_Cow");
        cowNode.active = true;
        
        let dbCom = cowNode.getComponentInChildren(dragonBones.ArmatureDisplay);

        dbCom.playAnimation(comboType,1);
        
        let self = this;
        if (seatSide == 0) {
            this.getUserData(Number(playerId), (data : IUserData) => {

                let gender = data.gender == 1? "female_" : "male_";
                self.playSoundInTable(gender + comboType,0.2);
            });
        } 
    }

    private sortPoker(sortType : number, comboType : string,settlePokers : GameProto.BullBullGame.IPoker[]) : GameProto.BullBullGame.IPoker[]{

        //摊牌排序..
        let colors = ["S","H","C","D"];
        let numbers = ["K","Q","J","10","9","8","7","6","5","4","3","2","A"];
        let pokerCombos = [];

        numbers.forEach(num => {
            colors.forEach(color => {                
                pokerCombos.push(num + color);
            });
        });
        
        if (comboType == "silvercow") {
         
            //需要自己排序
            settlePokers = settlePokers.sort( (a,b)=>{                
                return numbers[a.number] - numbers[b.number];
            });
        }
        else if(comboType == "boom"){

            //需要自己排序

            let boomPoker = new GameProto.BullBullGame.Poker();
            boomPoker.colour = settlePokers[0].colour;
            boomPoker.number = settlePokers[0].number;

            let find = false;
            for (let index = 1; index < settlePokers.length; index++) {
                const poker = settlePokers[index];
                if (boomPoker.number == poker.number) {    
                    find = true;                
                    break;
                }
            }

            if (!find) {
                boomPoker.number = settlePokers[1].number;                
                boomPoker.colour = settlePokers[1].colour;
            }

            for (let index = 0; index < settlePokers.length; index++) {
                const poker = settlePokers[index];
                if (poker.number != boomPoker.number) {
                    //放在最后一个位置
                    let temp = new GameProto.BullBullGame.Poker();
                    temp.colour = poker.colour;
                    temp.number = poker.number;

                    settlePokers[index].number = boomPoker.number;
                    settlePokers[index].colour = boomPoker.colour;

                    settlePokers[settlePokers.length - 1].number = temp.number;
                    settlePokers[settlePokers.length - 1].colour = temp.colour;
                    break;
                }
            }

        }        

        let arrayLeft = [];
        let arrayRight = [];
                         
        arrayLeft = settlePokers.filter((ele,index,array)=>{

            return index <= (sortType - 1);
        });   

        arrayRight = settlePokers.filter((ele,index,array)=>{

            return index > (sortType - 1);
        });
                 
        arrayLeft = this.sortPokerFuc(pokerCombos,arrayLeft);
        arrayRight = this.sortPokerFuc(pokerCombos,arrayRight);

        return arrayLeft.concat(arrayRight);
    }

    private sortPokerFuc(pokerCombos,pokers){

        pokers.sort((a,b)=>{
            let poker_a = a.number + a.colour;
            let poker_b = b.number + b.colour;

            let poker_a_index : number;
            let poker_b_index : number;

            for (let index = 0; index < pokerCombos.length; index++) {
                const poker = pokerCombos[index];
                
                if (poker == poker_a) {
                    poker_a_index = index;
                }
                else if (poker == poker_b) {
                    poker_b_index = index;
                }
            }

            return poker_a_index - poker_b_index;
        });

        return pokers;
    }


    public playSoundInTable(name : string,delay : number = 0){

        let path = "package/bullbull/audio/" + name;

        let self = this;
        this.doScheduleOnce(()=>{
            self.playSound(path);
        },delay);
        
    }


    public playAnimationInNode(name : string){
     
        let self = this;
        this.playAni(name,(load_node)=>{

            load_node.parent = self.nodeAnimation;
            load_node.position = cc.Vec3.ZERO;
            

            let ani = load_node.getComponent(cc.Animation);
            if (ani) {
                ani.resume();
                ani.play();
            }

        })
        
    }

    

    /**
     * 抢庄显示
     */
    public showScramble(seatSide : number,multiple : number){

        let node = this.playerNodes[seatSide];

        let scramle = node.getChildByName("Node_Scramble");
        scramle.active = true;

        let mid = scramle.getChildByName("Label_Num");

        let midSp = mid.getComponent(cc.Label);

        mid.active = true;
        
        if (multiple > 0) {

            midSp.string = "抢" + multiple.toString() + "倍";
            
        }else{

            midSp.string = "不";//不抢
        }        

        this.changeScramble(seatSide,false);
    }

    private changeScramble(seatSide : number,lockBanker? : boolean){

        let node = this.playerNodes[seatSide];
        let scramle = node.getChildByName("Node_Scramble");
        scramle.active = true;

        let mid = scramle.getChildByName("Label_Num");

        let midLabel = mid.getComponent(cc.Label);

        let showFont = midLabel.string != "不" || lockBanker;
                
        let bg1 = scramle.getChildByName("bg1");
        let bg0 = scramle.getChildByName("bg0");
        let lable_num = scramle.getChildByName("Label_Num");

        if (showFont) {
         
            let multiple = "1";//最小1倍
            if (midLabel.string != "不") {
            
                multiple = midLabel.string.substr(1,1);
            }

            midLabel.string = "x" + multiple;
            
            midLabel.font = this.lock_banker_font;
            midLabel.fontSize = 36;
            midLabel.lineHeight = 36;
            let bet = node.getChildByName("Node_Bet");
            scramle.position = new cc.Vec3(bet.position.x,bet.position.y);
            scramle.scale = 1;
            bg1.active = true;
            bg0.active = false;

            lable_num.position = new cc.Vec3(0.419,2.287);
        }      
        else{

            scramle.position =  cc.Vec3.ZERO;
            scramle.scale = 0.8;
            bg0.active = true;
            bg1.active = false;

            lable_num.position = new cc.Vec3(0.302,-2.274);
            
            midLabel.font = this.scramble_banker_font;
            midLabel.fontSize = 59;
            midLabel.lineHeight = 59;
        } 
                
        mid.active = true;
                
    }

    public showWinOrLossAni( bankerId : number,
        avatarId : number ,
        playerInfoMap : { [key:string ] : BullBullPlayerInfo },        
        settleActs : GameProto.BullBullGame.ISettleAccounts[],
        callback : Function){

        let self = this;
        
        let playerNums = settleActs.length;

        let avatarInfo = settleActs.filter( (ele,index,array)=>{

            return ele.playerId == avatarId;
        })[0];

        let bankerInfo = settleActs.filter( (ele,index,array)=>{

            return ele.playerId == bankerId;
        })[0];

        /**
        * 庄家通杀/通赔检测
        */
        let checkState = undefined;        

        /**
         * 通杀/通赔 false 表示没有
         */
        let checkResult = false;

        if (!bankerInfo.actualWinLoss) {
             
            cc.error(" actualWinLoss is undefined");
            return;
        }
        
        let tongsha = false;
        //所有玩家摊牌动画结束
        //结算表现..
        //输赢动画(通杀/通赔)
        if ( /*playerNums > 2 && */ bankerInfo) {
                        
            //庄家通杀/通赔判断
            if ( Number(bankerInfo.actualWinLoss) > 0) {
                
                checkState = 0; //通杀判断

            }else if(Number(bankerInfo.actualWinLoss) < 0){

                checkState = 1; //通赔判断
            }
                
            if (checkState != undefined ) {                 
                                                    
                checkResult = this.checkBankerWinOrLoss(checkState,bankerId,settleActs);
                //通杀 通赔功能 
                if ( checkResult && false  ) {                    
                    
                    if (checkState == 0) {
                        //通杀动画
                        this.playAnimationInNode("anim_niuniu_jiesuan_tongsha");

                        this.getUserData(Number(bankerId), (data : IUserData) => {

                            let gender = data.gender == 1? "female_" : "male_";                            
                            self.playSoundInTable(gender + "tongsha");
                            
                        });
                        
                    }
                    else{

                        //通赔动画
                        this.playAnimationInNode("anim_niuniu_jiesuan_tongpei");

                        this.getUserData(Number(bankerId), (data : IUserData) => {
                            let gender = data.gender == 1? "female_" : "male_";                            
                            self.playSoundInTable(gender + "tongpei");
                        });
                    }
                }
            }                

        }            

        //没有通杀通赔
        if(!checkResult){
            //胜利
            if ( Number(avatarInfo && avatarInfo.actualWinLoss) > 0 ) {            
            
                // this.playAnimationInNode("anim_niuniu_jiesuan_shengli");
                // this.playSoundInTable("win");                          
            }                         
        }          

        //飘金币 以庄家为准..
        let bankerSeatSide = playerInfoMap[bankerId].seatSide;

        //先飘赢 
        let delayShow = 0; 

        //音效
        let playFlySound : boolean = false;

        for (let index = 0; index < settleActs.length; index++) {
            const info = settleActs[index];
            if ( info.playerId != bankerId  ) {
                
                if( Number(info.actualWinLoss) < 0) {
                    let playerInfo = playerInfoMap[info.playerId]
                    //闲家飘输的分
                    self.turnNum(playerInfo.seatSide,Number(info.actualWinLoss)); 
                    self.updatePlayerInfo(playerInfo.seatSide,info.coinBalanceStr,info.playerId);
                    //输的闲家 钱给庄家
                    if (playerInfo) {
                        this.moveGoldToDest(playerInfo.seatSide,bankerSeatSide,(plySnd)=>{
                            if (!plySnd) {
                                self.playSoundInTable("flyCoins");                                     
                            }                                                                                                              
                        },playFlySound);
                    }       

                    playFlySound = true;

                    delayShow = 1.5;                        
                }                        
            }
        }

        //
        if (checkResult) {
            
            if (checkState == 0) {                
                //庄家通杀
                tongsha = true;
                this.doScheduleOnce(()=>{
                    self.addGoldFrame(bankerSeatSide);  
                    self.updatePlayerInfo(bankerSeatSide,bankerInfo.coinBalanceStr,bankerInfo.playerId);
                    self.turnNum(bankerSeatSide,Number(bankerInfo.actualWinLoss));
                },0.1);                              
            }
        }

        //再飘输
        this.scheduleOnce(()=>{
                  
            playFlySound = false;
            //庄家飘输的分 
            if (Number(bankerInfo.actualWinLoss) < 0) {
                self.turnNum(bankerSeatSide,Number(bankerInfo.actualWinLoss));     
                self.updatePlayerInfo(bankerSeatSide,bankerInfo.coinBalanceStr,bankerInfo.playerId);       
            }
            
            for (let index = 0; index < settleActs.length; index++) {
                const info = settleActs[index];
                if ( info.playerId != bankerId  ) {
                    
                    if( Number(info.actualWinLoss) > 0) {

                        //庄家给钱..
                        let playerInfo = playerInfoMap[info.playerId]
                        if (playerInfo) {
                         
                            self.moveGoldToDest(bankerSeatSide,playerInfo.seatSide,(plySnd)=>{
                                if (!plySnd) {
                                    self.playSoundInTable("flyCoins");                                      
                                }                                                                                                                                                                                   
                            },playFlySound);  
            
                            playFlySound = true;

                            self.doScheduleOnce(()=>{
                                //闲家飘赢的分
                                self.turnNum(playerInfo.seatSide,Number(info.actualWinLoss)); 
                                self.updatePlayerInfo(playerInfo.seatSide,info.coinBalanceStr,playerInfo.playerId);
                                self.addGoldFrame(playerInfo.seatSide);     
                            },0.1) 
                        }      
                    }
                }
            } 
            
            if (!tongsha && Number(bankerInfo.actualWinLoss) > 0) {
                self.doScheduleOnce(()=>{
                    self.turnNum(bankerSeatSide,Number(bankerInfo.actualWinLoss)); 
                    self.updatePlayerInfo(bankerSeatSide,bankerInfo.coinBalanceStr,bankerInfo.playerId);
                    self.addGoldFrame(bankerSeatSide); 
                },0.1)          
            }                  
            
            if (avatarInfo) {
             
                let avatarWinOrLossNum = Number(avatarInfo.actualWinLoss);
                let resultNode : cc.Node = avatarWinOrLossNum >= 0? self.winResultNode : self.lossResultNode;
                //输赢动画
                let path = "package/bullbull/audio/";
                if (avatarWinOrLossNum >= 0) {

                    resultNode = self.winResultNode;
                    path += "dummy_victory";
        
                }else{

                    resultNode = self.lossResultNode;     
                    path += "dummy_zero";           
                }

                
                self.playSound(path); 
                
                let resultCom : BullResultCom = resultNode.getComponent(BullResultCom); 
                resultCom.startPlay(avatarWinOrLossNum,callback); 

            }else{

                if (callback) {
                    callback();
                }
            }                            

        },delayShow);
        
    }

    public hideResultNode(){

        this.winResultNode.active = false;
        this.lossResultNode.active = false;
    }


    public turnNum( seatSide : number, finallyNum : number  ){

        //cc.warn(" turnNum " ,seatSide);
        let self = this;
        let negative = finallyNum < 0;

        let TIMES = 25;
        let sub = finallyNum / TIMES;
        let currentNum = 0;

        let node : cc.Node = this.playerNodes[seatSide];        
        if (!node) return; 

        if (seatSide == 0) {
            //自己
            this.eventDispatch("Game_Table_Settlement", this.exp_node);
        }

        let label_num = node.getChildByName("Label_Num");        
        let label = label_num.getComponent(cc.Label);
         
        let displayTimes = 0;
        this.doSchedule(()=>{
            
            if (++displayTimes == TIMES) {
                
                currentNum = finallyNum

            }else{

                currentNum += sub;

            }            
            let numStr = GameUtil.currencyFormatting(currentNum);                               
            
            if (numStr.indexOf("-") == -1) {                
                label.font = self.add_font;                
                label.string = "+" + numStr;
            }
            else{
                label.font = self.sub_font;
                label.string = numStr;
            }
            
        },0.033,TIMES - 1);

    }


    private getPlayerGoldNode(index : number) :  cc.Node{

        //return this.iconButtons[index].node;
        return this.coinMoveNodes[index];
    }


    private moveGoldToDest(srcIndex : number, destIndex : number, callback? : (...args :any)=>void , ...args : any[]){

        let self = this;
        let node_gold = this.getPlayerGoldNode(srcIndex);

        let destNode : cc.Node = this.getPlayerGoldNode(destIndex);

        //删除isMangoTable的判断  modif by dred 
        let url = BullBullConst.PREFAB_RES_PATH_BASE + "sprite/chip";

        for (let index = 0; index < 8; index++) {

            this.scheduleOnce(()=>{

                self.loadRes(url,(error,prefab : cc.Prefab)=>{
                
                    if (error) {
                        cc.warn(" load prefab error ",url);
                        return;
                    }
        
                    let loadPrefab = cc.instantiate(prefab);
                    loadPrefab.parent = node_gold;
                    loadPrefab.position = cc.Vec3.ZERO;
                    loadPrefab.angle = Utility.random(0,360);              
                    Utility.moveToArea(loadPrefab,destNode,0.5,1,35,()=>{

                        loadPrefab.destroy();         
                        
                        if (index == 0) {
                         
                            if (callback) {                            
                                callback(...args);
                            }
                        }                        
                        
                    });       
                });            
            },0.05 * index);
            
        }
    }

    /**
     * 通杀通赔判断 
     * @param settleActs 
     */
    private checkBankerWinOrLoss( checkValue : number, bankerId : number, settleActs : GameProto.BullBullGame.ISettleAccounts[] ) : boolean {


        for (let index = 0; index < settleActs.length; index++) {
            const info = settleActs[index];
            if ( info.playerId != bankerId  ) {
                
                //通杀判断  
                if (checkValue == 0 && Number(info.actualWinLoss) >= 0) {
                                   
                    return false;

                }else if (checkValue == 1 && Number(info.actualWinLoss) <= 0){

                    return false;
                }
            }            
        }

        return true;
    }
    

    public hideScrambleResult(all : boolean = true,seatSide? : number){

        if (all) {
            
            this.playerNodes.forEach(node => {
                
                let scramble = node.getChildByName("Node_Scramble");
                scramble.active = false;
            });
        }
        else{

            let node = this.playerNodes[seatSide];

            let scramble = node.getChildByName("Node_Scramble");
            scramble.active = false;
        }
    }

    /**
     * 下注显示
     */
    public showBetResult(seatSide : number, multiple : number ){

        let node = this.playerNodes[seatSide];        

        let bet = node.getChildByName("Node_Bet");
        bet.active = true;
        
        let mid = bet.getChildByName("Label_Num");
        let midSp = mid.getComponent(cc.Label);

        midSp.string = "x"+ multiple.toString();
    }

    public hideBetResult(all : boolean = true,seatSide? : number){

        if (all) {
            
            this.playerNodes.forEach(node => {
                
                let bet = node.getChildByName("Node_Bet");
                bet.active = false;
            });
        }
        else{

            let node = this.playerNodes[seatSide];

            let bet = node.getChildByName("Node_Bet");
            bet.active = false;
        }
    }

    public showIconMask(state : boolean,seatSide : number){

        
        let playerCom = this.getPlayerInfoCom(seatSide);

        //let mask = playerCom.maskNode.getChildByName("spriteMask");

        //let mask = node.getChildByName("Sprite_Mask");
        
        playerCom.showMask(state);

        //mask.active = state;
    }
    

    private getPlayerInfoCom(seatSide : number){

        let node = this.playerNodes[seatSide];
        return node.getComponent(BullPlayerInfoNode);
        

    }


}

